import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { Subject } from 'rxjs';
import { InformationType } from '../model/information_type.model';
import { Router } from '@angular/router';

@Component({
  selector: 'jhi-information-model',
  templateUrl: './information-model.component.html',
  styleUrls: []
})
export class InformationModelComponent implements OnInit {

  public myContent;
  public id;

  isUpdateType: boolean = false;
  title: string;
  message: string;
  mainList: any[] = [];

  public onClose: Subject<boolean>;

  constructor(
    public _bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private router: Router
  ) { }

  public ngOnInit(): void {
    this.onClose = new Subject();
    console.log(this.mainList)

  }

  ngAfterViewInit() {
    // console.log(this.myContent,"this.myContent");
  }

  public onConfirm(): void {
    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  navigateToMain(redirectType, redirectId, referenceId) {
    console.log(redirectType);
    var link = null;
    var newTab = "_blank"
    switch (redirectType) {
      case InformationType.INSURANCE_COMPANY: {
        link = '/insurance-company/' + redirectId + '/view';
        break;
      }
      case InformationType.UNDERWRITER: {
        link = '/underwriter/' + redirectId + '/view';
        break;
      }
      case InformationType.UNDERWRITER_INSURER: {
        link = '/underwriter-insurer-my-suffix/' + redirectId + '/' + referenceId + '/view';
        break;
      }
      case InformationType.SURVEY_ASSOCIATION: {
        link = '/survey-association/' + redirectId + '/view';
        break;
      }
      case InformationType.SURVEY_COMPANY: {
        link = '/survey-company/' + redirectId + '/view';
        break;
      }
      case InformationType.CARGO_GROUP: {
        link = '/cargo-group/' + redirectId + '/view';
        break;
      }
      case InformationType.PACKING_TYPE: {
        link = '/packing-type/' + redirectId + '/view';
        break;
      }
      case InformationType.LOADING_TYPE: {
        link = '/loading-type/' + redirectId + '/view';
        break;
      }
      case InformationType.PORT: {
        link = '/port/' + redirectId + '/view';
        break;
      }
      case InformationType.CLAUSE_EXTENSION: {
        link = '/clause-extension/' + redirectId + '/view';
        break;
      }
      case InformationType.P_AND_I_CLUB: {
        link = '/p-and-i-club/' + redirectId + '/view';
        break;
      }
      case InformationType.CLASSIFICATION_SOCIETY: {
        link = '/classification-society/' + redirectId + '/view';
        break;
      }
      case InformationType.TAX: {
        link = '/tax/' + redirectId + '/view';
        break;
      }
      case InformationType.WAR_STRIKE_LEVEL: {
        link = '/war-strike-level/' + redirectId + '/view';
        break;
      }
      case InformationType.SANCTIONED_GROUP: {
        link = '/sanctioned-group/' + redirectId + '/view';
        break;
      }
      case InformationType.INTRA_COUNTRY_BAN: {
        link = '/intra-country-ban/' + redirectId + '/view';
        break;
      }
      case InformationType.INCO_TERM: {
        link = '/inco-term/' + redirectId + '/view';
        break;
      }
      case InformationType.TRADE_TERM: {
        link = '/trade-term/' + redirectId + '/view';
        break;
      }
      case InformationType.BROKER: {
        link = '/broker/' + redirectId + '/view';
        break;
      }
      case InformationType.INSURER: {
        link = '/insurer/' + redirectId + '/view';
        break;
      }
      case InformationType.UNDERWRITER_USER: {
        link = '/underwriters/' + redirectId + '/view';
        break;
      }
      case InformationType.INTERNAL_STAFF: {
        link = '/internal-staff/' + redirectId + '/view';
        break;
      }
      case InformationType.CLIENT: {
        link = '/client/' + redirectId + '/view';
        break;
      }
      case InformationType.AUDITOR: {
        link = '/auditor/' + redirectId + '/view';
        break;
      }
      case InformationType.POLICY: {
        link = '/policy/' + redirectId + '/view';
        break;
      }
      case InformationType.SCOPE: {
        link = '/scope-my-suffix/' + redirectId + '/view';
        break;
      }
      case InformationType.RULE: {
        link = '/rule-my-suffix/' + redirectId + '/view';
        break;
      }
      case InformationType.STORAGE_RULE: {
        link = '/storage-rule-my-suffix-detail/' + redirectId + '/view';
        break;
      }

      default: {
        break;
      }
    }

    if (link) {
      this.router.navigate([]).then(result => { window.open(link, newTab); });
    }

  }

}
